import {
  ButtonOptionsMessage,
  ConversationLogItemMessageAdded,
} from '@stripe-internal/conversations-client';

export const THUMBS_DOWN_ADVANCE_OPTION_ID = 'feedback_thumbs_down_advance';

export function isButtonOptionsMessage(
  item: Pick<ConversationLogItemMessageAdded, 'message'> | null | undefined,
): item is ConversationLogItemMessageAdded & {message: ButtonOptionsMessage} {
  return item?.message.type === 'button-options-conversation-message';
}

/**
 * If an option menu is shown to user, e.g. top topics - and the user clicks thumbs down
 * we want to hide the option menu. They set this `feedback_thumbs_down_advance`
 *
 * @param item
 * @returns
 */
export function didUserSelectThumbsDownAdvanceButtonOptionsMessage(
  item: ConversationLogItemMessageAdded,
): item is ConversationLogItemMessageAdded & {message: ButtonOptionsMessage} {
  if (!isButtonOptionsMessage(item)) {
    return false;
  }
  return item.message.selectedOptionId === THUMBS_DOWN_ADVANCE_OPTION_ID;
}

export function didUserSelectGetSmartSuggestionsButtonOptionsMessage(
  item: ConversationLogItemMessageAdded,
): item is ConversationLogItemMessageAdded & {message: ButtonOptionsMessage} {
  if (!isButtonOptionsMessage(item)) {
    return false;
  }
  return item.message.selectedOptionId === 'get-smart-suggestions';
}
